import {Component, ViewEncapsulation} from "@angular/core";
import {LabeledDisplayComponent} from "../../../shared/labeled-display/labeled-display.component";
import {NgForOf} from "@angular/common";

@Component({
  standalone: true,
  templateUrl: './deals.component.html',
  imports: [
    LabeledDisplayComponent,
    NgForOf
  ],
  encapsulation: ViewEncapsulation.None
})

export class DealsComponent {
  constructor() {
  }
}
